import { render, staticRenderFns } from "./bygz_tchTree.vue?vue&type=template&id=e5d71c38&scoped=true"
import script from "./bygz_tchTree.vue?vue&type=script&lang=js"
export * from "./bygz_tchTree.vue?vue&type=script&lang=js"
import style0 from "./bygz_tchTree.vue?vue&type=style&index=0&id=e5d71c38&prod&lang=css"
import style1 from "./bygz_tchTree.vue?vue&type=style&index=1&id=e5d71c38&prod&lang=less"
import style2 from "./bygz_tchTree.vue?vue&type=style&index=2&id=e5d71c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d71c38",
  null
  
)

export default component.exports